module.exports = __webpack_public_path__ + "static/banner-acerca-fc3bc9ad1fafb84c53797d360f4b8927.jpg";